import type { JSX } from "react";
import { cn } from "./cn";

export interface AddButtonProps {
  /** Extra className */
  readonly className?: string;
  /** Click handler */
  readonly onClick?: () => void;
}

/**
 * A small "+" button used in section headers.
 */
export function AddButton({ className, onClick }: AddButtonProps): JSX.Element {
  return (
    <button
      className={cn(
        "w-5 h-5 rounded border border-edge text-content-tertiary text-xs inline-flex items-center justify-center cursor-pointer bg-transparent",
        className,
      )}
      type="button"
      onClick={onClick}
    >
      +
    </button>
  );
}
